import { ENRICH_DRAWER_SECTION } from '@groupby/enrich-console';
import { ModelType, PageIdentifier, Role, Routing, SectionPath, } from '@/constants';
import { hasEnrichAccessOnly } from '@/utils/environment';
import { NavigationType } from '@/navigation/types';
const MERCHANDISING_SECTION = {
    label: 'MERCHANDISING',
    path: SectionPath.MERCHANDISING,
    disabled: hasEnrichAccessOnly,
    categories: [
        {
            label: 'DRAWER_CATEGORY_BUILD_CAMPAIGNS',
            routes: [
                {
                    name: ModelType.RULE,
                    path: Routing.ROUTE_PATHS[ModelType.RULE],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'RULES',
                    roles: [Role.MERCHANDISING],
                },
                {
                    name: ModelType.NAVIGATION,
                    path: Routing.ROUTE_PATHS[ModelType.NAVIGATION],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'FACETS',
                    roles: [Role.ENGINE_CONFIGURATION],
                },
                {
                    name: ModelType.PRODUCT_RECOMMENDATIONS,
                    path: Routing.ROUTE_PATHS[ModelType.PRODUCT_RECOMMENDATIONS],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'PRODUCT_RECOMMENDATIONS',
                    roles: [Role.MERCHANDISING],
                    subroutes: [
                        {
                            name: ModelType.RECS_MODEL,
                            path: Routing.ROUTE_PATHS[ModelType.RECS_MODEL],
                            sectionPath: SectionPath.MERCHANDISING,
                            label: 'DRAWER_ITEM_MODEL_MANAGEMENT',
                            roles: [Role.MERCHANDISING],
                        },
                        {
                            name: ModelType.FILTER_SETS,
                            path: Routing.ROUTE_PATHS[ModelType.FILTER_SETS],
                            sectionPath: SectionPath.MERCHANDISING,
                            label: 'FILTER_SETS',
                            roles: [Role.MERCHANDISING],
                        },
                    ],
                },
            ],
        },
        {
            label: 'DRAWER_CATEGORY_MANAGE_PRODUCT_CATALOG',
            routes: [
                {
                    name: ModelType.ATTRIBUTES,
                    path: Routing.ROUTE_PATHS[ModelType.ATTRIBUTES],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'ATTRIBUTE_MANAGEMENT',
                    roles: [Role.MERCHANDISING],
                },
                {
                    name: ModelType.CATEGORIES,
                    path: Routing.ROUTE_PATHS[ModelType.CATEGORIES],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'CATEGORIES',
                    roles: [Role.MERCHANDISING],
                },
            ],
        },
        {
            label: 'DRAWER_CATEGORY_TUNE_THE_ENGINE',
            routes: [
                {
                    name: ModelType.BIASING_PROFILE,
                    path: Routing.ROUTE_PATHS[ModelType.BIASING_PROFILE],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'BIASING',
                    roles: [Role.ENGINE_CONFIGURATION],
                },
                {
                    name: ModelType.LINGUISTIC_CONTROLS,
                    path: Routing.ROUTE_PATHS[ModelType.LINGUISTIC_CONTROLS],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'LINGUISTIC_CONTROLS',
                    roles: [Role.MERCHANDISING],
                },
                {
                    name: ModelType.REDIRECT,
                    path: Routing.ROUTE_PATHS[ModelType.REDIRECT],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'REDIRECTS',
                    roles: [Role.QUERY_REWRITE],
                },
                {
                    name: PageIdentifier.EVALUATE,
                    path: Routing.ROUTE_PATHS[PageIdentifier.EVALUATE],
                    sectionPath: SectionPath.MERCHANDISING,
                    drawerStateOverrides: {
                        navigationType: NavigationType.PRIMARY,
                        isDrawerOpen: false,
                    },
                    label: 'EVALUATION_TOOL',
                    roles: [Role.ENGINE_CONFIGURATION],
                },
            ],
        },
        {
            label: 'DRAWER_CATEGORY_CREATE_CONTENT',
            routes: [
                {
                    name: ModelType.ZONE,
                    path: Routing.ROUTE_PATHS[ModelType.ZONE],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'ZONES',
                    roles: [Role.MERCHANDISING],
                },
                {
                    name: ModelType.TEMPLATE,
                    path: Routing.ROUTE_PATHS[ModelType.TEMPLATE],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'TEMPLATES',
                    roles: [Role.MERCHANDISING],
                },
                {
                    name: ModelType.PREVIEW_WRAPPER,
                    path: Routing.ROUTE_PATHS[ModelType.PREVIEW_WRAPPER],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'PREVIEW_WRAPPER',
                    roles: [Role.MERCHANDISING],
                },
            ],
        },
        {
            label: 'DRAWER_CATEGORY_CONFIGURE_PLATFORM',
            routes: [
                {
                    name: ModelType.TAG,
                    path: Routing.ROUTE_PATHS[ModelType.TAG],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'TAG_MANAGEMENT',
                    roles: [Role.MERCHANDISING],
                },
                {
                    name: ModelType.SITE,
                    path: Routing.ROUTE_PATHS[ModelType.SITE],
                    sectionPath: SectionPath.MERCHANDISING,
                    label: 'SITE_MANAGEMENT',
                    roles: [Role.MERCHANDISING],
                },
            ],
        },
    ],
};
const getAnalyticsSection = ({ isNewSearchPerformanceDashboard }) => ({
    label: 'ANALYTICS',
    path: SectionPath.ANALYTICS,
    hasLazyLoadedRoutes: true,
    disabled: hasEnrichAccessOnly,
    categories: [
        {
            label: 'DRAWER_CATEGORY_ENHANCE_PERFORMANCE',
            routes: [
                {
                    name: PageIdentifier.ANALYTICS,
                    path: Routing.ROUTE_PATHS[PageIdentifier.ANALYTICS],
                    sectionPath: SectionPath.ANALYTICS,
                    label: 'ANALYTICS',
                    roles: [Role.MERCHANDISING],
                },
                ...(isNewSearchPerformanceDashboard ? [
                    {
                        name: PageIdentifier.SEARCH_PERFORMANCE,
                        path: Routing.ROUTE_PATHS[PageIdentifier.SEARCH_PERFORMANCE],
                        sectionPath: SectionPath.ANALYTICS,
                        label: 'SEARCH_PERFORMANCE',
                        roles: [Role.MERCHANDISING],
                    },
                ] : []),
            ],
        },
        {
            label: 'DRAWER_CATEGORY_CHECK_SITE_HEALTH',
            routes: [
                {
                    name: PageIdentifier.SEARCH_DATA_QUALITY,
                    path: Routing.ROUTE_PATHS[PageIdentifier.SEARCH_DATA_QUALITY],
                    sectionPath: SectionPath.ANALYTICS,
                    label: 'SEARCH_DATA_QUALITY',
                    roles: [Role.ADMIN, Role.MERCHANDISING],
                },
            ],
        },
        {
            label: 'PIPELINE_HEALTH',
            routes: [
                {
                    name: PageIdentifier.PIPELINE_HEALTH,
                    path: Routing.ROUTE_PATHS[PageIdentifier.PIPELINE_HEALTH],
                    sectionPath: SectionPath.ANALYTICS,
                    label: 'PIPELINE_HEALTH',
                    roles: [Role.ADMIN, Role.MERCHANDISING],
                },
            ],
        },
    ],
});
const ADMIN_SECTION = {
    label: 'ADMIN',
    path: SectionPath.ADMIN,
    categories: [
        {
            label: 'DRAWER_CATEGORY_MANAGE_PEOPLE',
            routes: [
                {
                    name: ModelType.USER,
                    path: Routing.ROUTE_PATHS[ModelType.USER],
                    sectionPath: SectionPath.ADMIN,
                    label: 'USER_MANAGEMENT',
                    roles: [Role.ADMIN],
                },
            ],
        },
        {
            label: 'DRAWER_CATEGORY_CONFIGURE_PLATFORM',
            routes: [
                {
                    name: ModelType.INGESTION_TASKS,
                    path: Routing.ROUTE_PATHS[ModelType.INGESTION_TASKS],
                    sectionPath: SectionPath.ADMIN,
                    label: 'INGESTION_TASKS',
                    roles: [Role.ADMIN],
                    disabled: hasEnrichAccessOnly,
                },
                {
                    name: ModelType.AREA,
                    path: Routing.ROUTE_PATHS[ModelType.AREA],
                    sectionPath: SectionPath.ADMIN,
                    label: 'AREA_MANAGEMENT',
                    roles: [Role.ADMIN],
                    disabled: hasEnrichAccessOnly,
                },
                {
                    name: ModelType.IMAGE_PATH,
                    path: Routing.ROUTE_PATHS[ModelType.IMAGE_PATH],
                    sectionPath: SectionPath.ADMIN,
                    label: 'IMAGE_PATH',
                    roles: [Role.ADMIN],
                    disabled: hasEnrichAccessOnly,
                },
                {
                    name: ModelType.AUTOCOMPLETE,
                    path: Routing.ROUTE_PATHS[ModelType.AUTOCOMPLETE],
                    sectionPath: SectionPath.ADMIN,
                    label: 'AUTOCOMPLETE',
                    roles: [Role.ADMIN],
                    disabled: hasEnrichAccessOnly,
                },
            ],
        },
    ],
};
const SEO_STUDIO_SECTION = {
    label: 'SEO_STUDIO',
    path: SectionPath.SEO_STUDIO,
    categories: [
        {
            label: 'SEO_STUDIO_MANAGEMENT',
            routes: [
                {
                    name: PageIdentifier.SEO_DASHBOARD,
                    path: Routing.ROUTE_PATHS[PageIdentifier.SEO_DASHBOARD],
                    sectionPath: SectionPath.SEO_STUDIO,
                    label: 'SEO_STUDIO_DASHBOARD',
                    roles: [Role.SEO_MANAGER],
                },
                {
                    name: PageIdentifier.KEYWORD_SUGGESTIONS,
                    path: Routing.ROUTE_PATHS[PageIdentifier.KEYWORD_SUGGESTIONS],
                    sectionPath: SectionPath.SEO_STUDIO,
                    label: 'KEYWORDS',
                    roles: [Role.SEO_MANAGER],
                },
                {
                    name: PageIdentifier.SITEMAP,
                    path: Routing.ROUTE_PATHS[PageIdentifier.SITEMAP],
                    sectionPath: SectionPath.SEO_STUDIO,
                    label: 'SEO_STUDIO_SITEMAP',
                    roles: [Role.SEO_MANAGER],
                },
                {
                    name: PageIdentifier.SEO_SUITE_SETTINGS,
                    path: Routing.ROUTE_PATHS[PageIdentifier.SEO_SUITE_SETTINGS],
                    sectionPath: SectionPath.SEO_STUDIO,
                    label: 'SEO_SUITE_SETTINGS',
                    roles: [Role.SEO_MANAGER],
                },
            ],
        },
    ],
};
export const createDrawerConfig = ({ isNewSearchPerformanceDashboard, }) => {
    const drawerConfig = {
        sections: [
            MERCHANDISING_SECTION,
            getAnalyticsSection({ isNewSearchPerformanceDashboard }),
            ADMIN_SECTION,
            SEO_STUDIO_SECTION,
            Object.assign(Object.assign({}, ENRICH_DRAWER_SECTION), { showAlways: true }),
        ],
    };
    return drawerConfig;
};
